// react
import React from 'react'

// components
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import Header from '_components/header/index.jsx'
import NewEntityDialog from '_components/new-entity-dialog/index.jsx'
import ListView from '_components/list-view/index.jsx'

class PixelsPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      companies: [],
      modalOpen: false,
    }
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
    }))
  }

  render() {
    let { modalOpen } = this.state

    return (
      <div id="pixels-page">
        <Header
          title="Pixels"
          actions={[
            {
              children: 'Create New Pixel',
              onClick: this.toggleModal,
            },
          ]}
        />
        <ListView
          columns={[
            {
              key: 'name'
            },
            {
              key: 'pixel_class.name'
            },
            {
              key: 'order'
            },
            {
              key: 'url'
            },
            {
              key: 'created_by.email'
            },
            {
              key: 'created_at'
            }
          ]}
          entities="pixels"
          fields={['name', 'pixel_class.name', 'order', 'url', 'created_by.email', 'created_at']}
          filters={[{ name: 'pixel_class.name' }, { name: 'created_by.email' }]}
          searchable={true}
          sort_key={'order'}
          sort_dir={1}
        />
        <Dialog open={modalOpen} close={this.toggleModal}>
          <NewEntityDialog
            close={this.toggleModal}
            entities="Pixels"
            title="Enter a name for your new Pixel"
          />
        </Dialog>
      </div>
    )
  }
}

// export
export default PixelsPage
